import React, {useEffect, useState} from 'react';

interface Props {
  rotationRate?: number;
  previewUrls?: string[];
}

const RotatableMediaCard = ({rotationRate = 5, previewUrls = []}: Props) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (previewUrls.length <= 1) return;

    const rate = (rotationRate + Math.random()) * 1000;

    const rotate = () => {
      setCurrent((prev) => (prev + 1) % previewUrls.length);
    };

    const timer = setInterval(rotate, rate);
    return () => clearInterval(timer);
  }, [previewUrls, rotationRate]);

  const previewUrl = previewUrls[current];

  const mediaClasses = previewUrl ? 'media-card-media' : 'media-card-media media-card-placeholder';

  const mediaStyles = previewUrl ? {backgroundImage: `url(${previewUrl})`} : {};

  return <div className={mediaClasses} style={mediaStyles} />;
};

export default RotatableMediaCard;
